import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import { SimpleSelect } from 'react-selectize-advizr';
import PlanImpact from '../../PlanImpact/PlanImpactContainer';
import AdvForm from '../../../CommonComponents/AdvForm';
import Footer from '../../Footer/FooterContainer';
import Loading from '../../Loading/LoadingView';
import { isNumeric, isUuid, createCustomPropType } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import { simpleSelectDefaultValue  } from '../../../Profile/Accounts_react/AccountsUtils';

class GoalYearChangesView extends Component {
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;
    fetchData(clientId, fpId, goalId, whatIfTemplate.WhatIfType);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(previousProps) {
    const {
      clientId, fpId, goalId, whatIf, fetchPlanImpact, whatIfTemplate,
    } = this.props;

    const impactTriggerProps = ['whatIf'];

    if (!isEqual(pick(this.props, impactTriggerProps), pick(previousProps, impactTriggerProps))) {
      fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
    }
  }

  render() {
    const {
      goalId,
      clientId,
      loading,
      title,
      groupTitle,
      fpId,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      areOptionsLoaded,
      planImpactItems,
      onYearChange,
      yearsOptions: rawYearsOptions,
      year,
    } = this.props;

    const yearsOptions = [{ label: 'At Retirement', value: 'PurchaseAtRetirement' }].concat(rawYearsOptions);

    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <AdvForm>
            <ValidationErrors clientId={clientId} />
            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>
              <li className="what-ifs-form-field">
                <SimpleSelect
                  className="what-ifs-simple-select what-ifs-goal-year-select"
                  value={simpleSelectDefaultValue(yearsOptions, whatIf.PurchaseAtRetirement ? 'PurchaseAtRetirement' : year)}
                  onValueChange={value => onYearChange(clientId, goalId, whatIfTemplate.WhatIfType, value)}
                  options={yearsOptions}
                />
              </li>
            </ul>
          </AdvForm>
        </div>
        <PlanImpact clientId={clientId} planImpactItems={planImpactItems} />
        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}
GoalYearChangesView.defaultProps = {
  title: 'Untitled What If',
  groupTitle: 'Untitled What If Group',
};

GoalYearChangesView.propTypes = {
  planImpactItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    current: PropTypes.string.isRequired,
    proposed: PropTypes.string.isRequired,
  })).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  onYearChange: PropTypes.func.isRequired,
  yearsOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  year: createCustomPropType(isNumeric).isRequired,
};

export default GoalYearChangesView;
